export const role = {
  role: "Roles",
  title_create: "Create a role",
  form: { title: "Create a role", title_edit: "Edit a role" },
  create_form: {
    title: "Create a role",
    name: "Name",
    name_placeholder: "Role name",

    submit: "Create",
    creating: "Creating...",
    updating: "Updating...",
    update: "Update",
    create_success: "Role created successfully!",
    update_success: "Role updated successfully!",
    deactivate_success: "Role deactivated successfully!",
    create_error: "Error creating the role",
    update_error: "Error updating the role",
    deactivate_error: "Error deactivating the role",
    status: "Status",
    permission: "Permissions",
  },

  permission: {
    CREATE_COMPANY: "Create a company",
    UPDATE_COMPANY: "Edit a company",
    DELETE_COMPANY: "Delete a company",
    READ_COMPANY: "View companies",

    CREATE_CONTRAT: "Create a contract",
    READ_CONTRAT: "View contracts",

    CREATE_INVOICE: "Create an invoice",
    READ_INVOICE: "View invoices",
    UPDATE_INVOICE: "Edit an invoice",
    DELETE_INVOICE: "Delete an invoice",

    CREATE_QUOTE: "Create a quote",
    READ_QUOTE: "View quotes",
    UPDATE_QUOTE: "Edit a quote",
    DELETE_QUOTE: "Delete a quote",

    CREATE_SUPPLIER: "Create a supplier",
    READ_INVOICE_SUPPLIER: "View supplier invoices",

    CREATE_CREDIT_NOTE: "Create a credit note",
    READ_CREDIT_NOTE: "View credit notes",
    UPDATE_CREDIT_NOTE: "Edit a credit note",
    DELETE_CREDIT_NOTE: "Delete a credit note",

    CREATE_EXPENSE: "Create an expense",
    READ_EXPENSE: "View expenses",
    UPDATE_EXPENSE: "Edit an expense",
    DELETE_EXPENSE: "Delete an expense",

    CREATE_CLIENT: "Create a client",
    READ_CLIENT: "View clients",
    UPDATE_CLIENT: "Edit a client",
    DELETE_CLIENT: "Delete a client",

    CREATE_OFFER: "Create an offer",
    READ_OFFER: "View offers",
    UPDATE_OFFER: "Edit an offer",
    DELETE_OFFER: "Delete an offer",

    CREATE_USER: "Create a user",
    EDIT_USER: "Edit a user",
    DELETE_USER: "Delete a user",
    READ_USER: "View users",

    create_role: "Create a role",
    edit_role: "Edit a role",
    delete_role: "Delete a role",
    view_role: "View roles",

    view_dashboard: "View the dashboard",
    SIGNATURE: "Sign",
    DOCUMENT: "Documents",
    CONFIGURATION: "Configuration",
    VALIDATEUR: "Validator",
  },

  actions: {
    edit: "Edit",
    disable: "Disable",
    enable: "Enable",
    consulter: "View",
  },

  header_title: "Roles list",
  table: {
    status: "Status",
    isVerified: "Verified",
    createdAt: "Creation date",
  },
  COMPANY: "Company", // Société
  CONTRAT: "Contract", // Contrat
  INVOICE: "Invoice", // Facture
  QUOTE: "Quote", // Devis
  SUPPLIER: "Supplier", // Fournisseur
  CREDIT_NOTE: "Credit Note", // Avoir
  EXPENSE: "Expense", // Dépense
  CLIENT: "Client", // Client
  OFFER: "Offer", // Offre
  USER: "User", // Utilisateur
  ROLE: "Role", // Rôle
  DASHBOARD: "Dashboard", // Tableau de bord
  OTHER: "Other", // Autre
};
